// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rDNA-chartHeader {
  display: flex;
  flex-direction: row;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-chartHeader .rDNA-subheader, .rDNA-chartHeader .rDNA-header {
  font-family: "Dm Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
}

/*
\$theme-darkGray: #7D7979;
\$theme-lightGray: #BDBDBD;
\$theme-peach: #FFF2E1;
\$theme-yellow: #FFBB64;
\$theme-orange: #FF9001;
\$theme-blue: #2A296F;
\$sub-header-theme: #95a5a6;*/
.rDNA-chartHeader {
  align-items: flex-end;
  border-bottom: 5px solid #1B3E78;
  margin-bottom: 15px;
  text-align: start;
}
.rDNA-chartHeader .rDNA-chartHeadLeft {
  flex: 1;
  margin-bottom: 5px;
}
.rDNA-chartHeader .rDNA-header {
  margin: 0;
  color: #1B3E78;
}
.rDNA-chartHeader .rDNA-subheader {
  margin: 0;
  color: #0CAD99;
}
.rDNA-chartHeader .rDNA-header[contenteditable=true],
.rDNA-chartHeader .rDNA-subheader[contenteditable=true] {
  background-color: #fcf8e3 !important; /* Light yellow */
  border: 1px solid #ff5733 !important; /* Orange */
  padding: 5px; /* Optional: Adds spacing */
}
.rDNA-chartHeader .rDNA-chartHeadLogo {
  position: relative !important;
  max-width: 120px;
}
.rDNA-chartHeader .rDNA-chartHeaderRight {
  height: 45px;
  margin-bottom: 5px;
  flex: 0 0 auto;
  max-width: 120px;
}

@media screen and (max-width: 767.7px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 12px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 10px;
  }
  .rDNA-chartHeader .rDNA-chartHeadLeft {
    margin-right: 25px;
  }
}
@media screen and (max-width: 1023.7px) and (min-width: 768px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 14px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 12px;
  }
}
@media screen and (max-width: 1199.7px) and (min-width: 1024px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 14px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 12px;
  }
}
@media screen and (max-width: 1439.7px) and (min-width: 1200px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 14px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 12px;
  }
}
@media screen and (min-width: 1440px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 16px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/placeholders/_flexboxes.scss","webpack://./src/app/lbarometer/toolbox/charts/lb-chart-header/lb-chart-header.component.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./src/app/lbarometer/styles.scss"],"names":[],"mappings":"AAMA;EAC0B,aAAA;EACA,mBAAA;ACL1B;;ACHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADMF;ACHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADKF;ACFA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADIF;ACDA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADGF;ACAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADEF;ACCA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADCF;ACEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADAF;ACGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADDF;ACIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADFF;ACKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADHF;ACMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ADJF;ACOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADLF;ACQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ADNF;ACSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ADPF;ACUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADRF;ACWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADTF;ACYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADVF;ACaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADXF;AEzGA;;;;;uBAAA;ADPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADwHF;ACrHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADuHF;ACpHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADsHF;ACnHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADqHF;AClHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADoHF;ACjHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADmHF;AChHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADkHF;AC/GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADiHF;AC9GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADgHF;AC7GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AD+GF;AC5GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AD8GF;AC3GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AD6GF;AC1GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AD4GF;ACzGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AD2GF;ACxGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AD0GF;ACvGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADyGF;ACtGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADwGF;ACrGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADuGF;AE3NA;;;;;uBAAA;ACaA;ECJE,kCFXY;EEYZ,eDG2C;ECF3C,gBATiF;EAUjF,kBALgB;AJgOlB;;AK9OA;;;;;;;4BAAA;ALQA;EAEE,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,iBAAA;AAgPF;AA9OE;EACE,OAAA;EACA,kBAXS;AA2Pb;AA9OE;EACE,SAAA;EAEA,cEPQ;AFsPZ;AA7OE;EACE,SAAA;EAEA,cKXW;ALyPf;AA3OE;;EAEE,oCAAA,EAAA,iBAAA;EACA,oCAAA,EAAA,WAAA;EACA,YAAA,EAAA,2BAAA;AA6OJ;AA1OE;EACE,6BAAA;EACA,gBAAA;AA4OJ;AA1OE;EACE,YAAA;EACA,kBArCS;EAsCT,cAAA;EACA,gBAAA;AA4OJ;;AAxOA;EAEI;IAAe,eAAA;EA2OjB;EA1OE;IAAkB,eAAA;EA6OpB;EA5OE;IAAsB,kBAAA;EA+OxB;AACF;AA5OA;EAEI;IAAe,eAAA;EA8OjB;EA7OE;IAAkB,eAAA;EAgPpB;AACF;AA7OA;EAEI;IAAe,eAAA;EA+OjB;EA9OE;IAAkB,eAAA;EAiPpB;AACF;AA9OA;EAEI;IAAe,eAAA;EAgPjB;EA/OE;IAAkB,eAAA;EAkPpB;AACF;AA/OA;EAEI;IAAe,eAAA;EAiPjB;EAhPE;IAAkB,eAAA;EAmPpB;AACF","sourcesContent":["\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n","@import \"placeholders/flexboxes\";\n@import \"variables\";\n@import \"placeholders/fonts\";\n@import \"variables/breakpoints\";\n@import \"./../../../styles.scss\";\n\n$box-margin: 5px;\n\n.rDNA-chartHeader {\n  @extend %flex-row;\n  align-items: flex-end;\n  border-bottom: 5px solid $theme-secondary;\n  margin-bottom: 15px;\n  text-align: start;\n\n  .rDNA-chartHeadLeft {\n    flex: 1;\n    margin-bottom: $box-margin;\n  }\n  .rDNA-header {\n    margin: 0;\n    @extend %font-16px-bold;\n    color: $dark-text;\n  }\n  .rDNA-subheader {\n    margin: 0;\n    @extend %font-16px-bold;\n    color: $theme-accent;\n  }\n\n  .rDNA-header[contenteditable=\"true\"],\n  .rDNA-subheader[contenteditable=\"true\"] {\n    background-color: #fcf8e3 !important; /* Light yellow */\n    border: 1px solid #ff5733 !important; /* Orange */\n    padding: 5px; /* Optional: Adds spacing */\n  }\n\n  .rDNA-chartHeadLogo {\n    position: relative !important;\n    max-width: 120px;\n   }\n  .rDNA-chartHeaderRight {\n    height: 45px;\n    margin-bottom: $box-margin;\n    flex: 0 0 auto; // Prevent from growing or shrinking\n    max-width:120px;\n  }\n}\n\n@media screen and (max-width: $breakpoint-sm-max ) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 12px; }\n    .rDNA-subheader { font-size: 10px; }\n    .rDNA-chartHeadLeft { margin-right: 25px; }\n  }\n}\n\n@media screen and (max-width: $breakpoint-md-max ) and (min-width: $breakpoint-md-min) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 14px; }\n    .rDNA-subheader { font-size: 12px; }\n  }\n}\n\n@media screen and (max-width: $breakpoint-lg-max ) and (min-width: $breakpoint-lg-min) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 14px; }\n    .rDNA-subheader { font-size: 12px; }\n  }\n}\n\n@media screen and (max-width: $breakpoint-xl-max ) and (min-width: $breakpoint-xl-min) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 14px; }\n    .rDNA-subheader { font-size: 12px; }\n  }\n}\n\n@media screen and (min-width: $breakpoint-xxl-min ) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 16px; }\n    .rDNA-subheader { font-size: 14px; }\n  }\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","/*\n$theme-darkGray: #7D7979;\n$theme-lightGray: #BDBDBD;\n$theme-peach: #FFF2E1;\n$theme-yellow: #FFBB64;\n$theme-orange: #FF9001;\n$theme-blue: #2A296F;\n$sub-header-theme: #95a5a6;*/\n\n//----\n\n$theme-primary: #3792BF; \n$theme-secondary: #1B3E78; \n$theme-color3: #AACCFF; \n$theme-color4: #BDBDBD; \n$theme-color5: #7D7979; \n$theme-accent: #0CAD99; \n\n$text-gray:#787c95;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
